<template>
  <div class="vertify-box" id="vertifyBox">
    <div id="canvas_wrap"></div>
    <dr-row style="margin-top:20px" justifyContent="space-between" alignItems="center">
      <div @click="getSliderInfo">{{bigImageBase64!=''?'刷新':''}}</div>
      <div @click="close">关闭</div>
    </dr-row>
  </div>
</template>

<script>
import slider from "./js/slider.js";
import {getPicCode} from '@/request/login.js'
export default {
  data () {
    return {
      isRefresh: false,
      silderWidth: "",
      silderHeight: "",
      imgArr: [require("./images/timg.jpg"), require("./images/timg1.png")],
      sliderIcon: require("./images/slider-icon.png"),
      refreshIcon: require("./images/refresh.png"),
      sliderW: 60,
      siderId:"",
      posY:"",
      smallImageBase64:"",
      bigImageBase64:"",
      rateX:"",
    };
  },
  mounted () {
  },
  methods: {
    //获取滑动信息
    getSliderInfo () {
      getPicCode().then(res=>{
        if (res.code == 0) {
          let bigWidth = res.data.bigWidth
          this.silderWidth = document.getElementById("vertifyBox").clientWidth - 20
          let bigHeight = res.data.bigHeight
          this.silderHeight = this.silderWidth / bigWidth * bigHeight
          this.sliderW = (this.silderWidth / bigWidth) * res.data.smallWidth
          this.posY = (res.data.posY / res.data.bigHeight) * this.silderHeight
          this.smallImageBase64 = 'data:image/png;base64,'+res.data.smallImageBase64
          this.bigImageBase64 ='data:image/png;base64,'+res.data.bigImageBase64
          this.rateX = this.silderWidth / bigWidth
          this.siderId = res.data.id
          this.$nextTick(()=>{
            this.info()
          })
        } else {
          this.$toast(res.msg)
        }
      })
    },
    info: function () {
      let silderFun = slider.slider;
      let _that = this;
      let params = {
        el: "#canvas_wrap",
        w: _that.silderWidth,
        h: _that.silderHeight,
        bigImageBase64: _that.bigImageBase64,
        smallImageBase64:_that.smallImageBase64,
        sliderIcon: _that.sliderIcon,
        sliderW: _that.sliderW,
        rateX:_that.rateX,
        siderId:_that.siderId,
        posY:_that.posY,
        finish: function (obj) {
          _that.$emit("result",obj)
          _that.$emit('update:isSuccess', obj.status);
          _that.$emit('update:sliderId', obj.status?obj.sliderId:"");
          if (!obj.status) { //失败刷新滑动验证信息
            _that.getSliderInfo()
          }
        },
      };
      silderFun(params);
    },
    close () {
      this.$emit('close')
    }
  },
};
</script>

<style scoped>
.vertify-box {
  padding: 10px;
}
#canvas_wrap canvas {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/components/sliderVertify/index.vue